export const SET_CENTROS_CUSTOS_ACTION = 'centrosCustos';
export const SET_SOLICITANTES_ACTION = 'solicitantes';
export const SET_PRODUTO_ACTION = 'produto';
export const SET_PROJETO_ACTION = 'projeto';
export const SET_SEARCH_TEXT_ACTION = 'searchText';
export const SET_EMPRESA_ACTION = 'empresa';
export const SET_GRUPO_ACTION = 'grupo';
